<template>
  <div id="app">
    <header class="header-wrap">
      <div class="header-center">
        <div class="logo-wrap">
          <a href="">
            <img class="lazyLoad isLoaded" src="./images/jnr-v3.png"/>
          </a>
        </div>
        <nav class="nav-wrap" :class="getMainActive ? 'is-active' : ''">
          <ul>
            <li>
              <a href="javascript:void(0)" id="nav-home" @click="navHandle(1)" :class="isMenuItemActive(1) ? 'is-active' : ''">{{$tt('多元模版')}}</a>
            </li>
            <li>
              <a id="scroll-cm" href="javascript:void(0)" @click="navHandle(2)" :class="isMenuItemActive(2) ? 'is-active' : ''">{{$tt('合作模式')}}</a>
            </li>
            <li>
              <a id="scroll-pd" href="javascript:void(0)" @click="navHandle(3)" :class="isMenuItemActive(3) ? 'is-active' : ''">{{$tt('产品类型')}}</a>
            </li>
            <li>
              <a id="scroll-brand" href="javascript:void(0)" @click="navHandle(4)" :class="isMenuItemActive(4) ? 'is-active' : ''">{{$tt('品牌优势')}}</a>
            </li>
            <li>
              <a id="scroll-partner" href="javascript:void(0)" @click="navHandle(5)" :class="isMenuItemActive(5) ? 'is-active' : ''">{{$tt('合作伙伴')}}</a>
            </li>
            <li @click="showLang()">
              <span class="language-selector">{{ currentLang == 'en'? "English": $tt("中文") }}</span>
              <div class="lang-wrapper" :class="isActiveLang ? 'lang-active' : ''">
                <span @click="switchLang('en')" class="lang-option">English</span>
                <span @click="switchLang('ch')" class="lang-option">{{$tt('中文')}}</span>                
              </div>
              <!-- <label  @click="switchLang()">
                  
                  <input id="langCheck" type="checkbox">
                  <span class="slider"></span>
                  <span class="labels" data-on="EN" data-off="CH"></span>
              </label> -->
            </li>
          </ul>
        </nav>
        <button class="nav-menu-btn" :class="getMainActive ? 'is-active' : ''" @click="handleClick"></button>
        <button class="nav-filter-btn" :class="filterActive ? 'is-active' : ''" @click="filterHandler" :style="getStyleButton"></button>
      </div>
    </header>
    <router-view></router-view>
  </div>
</template>

<script type="application/javascript">
import { WOW } from "wowjs";
import config from "./config";
import { mapGetters } from 'vuex'

export default {
  name: "app",
  data() {
    return {
      currentLang: '',
      config,
      openNav: false,
      navIndex: 1,
      isActive: false,
      isLanguageActive: false,
    };
  },
  watch: {
    $route(v, v1) {
      console.log(v, v1, "v, v1");
    },
  },
  methods: {
    showLang(){
      this.isLanguageActive = !this.isLanguageActive;
    },
    switchLang(lang){
      localStorage.setItem('language', lang);
      setTimeout(() => {
            window.location.reload();
      }, 500);
    },    
    navHandle(index) {
      this.navIndex = index;
      this.$store.commit('setActiveIndex', index)
      this.$store.commit('setMainMenuActive', false) 
    },
    handleClick() {  
      this.$store.commit('setMainMenuActive', !this.getMainActive) 
    },
    filterHandler() {
      this.$store.commit('setFilterActive', !this.filterActive)
    },
    isMenuItemActive(index){
      return this.navIndex === index;
    },
    hideMenu(){      
      this.isActive = false;
      this.$store.commit('setFilterActive', false)
    }
  },
  computed : {
    ...mapGetters([
      'filterActive',
      'getMainActive'
    ]),
    isActiveLang(){
      return this.isLanguageActive
    },
    getStyleButton() {
      return this.navIndex > 1 ? 'display:none;' : '' ;
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      var wow = new WOW({
        live: false,
      });
      wow.init();
    });
    this.isLanguageActive = false,
    document.title = this.config.tenantName;
    $(window).on('resize', this.hideMenu);

    this.currentLang = localStorage.getItem('language');
   
  },
};
</script>

<style scoped>
@import "./css/reset.css";
@import "./css/animate.min.css";
@import "./css/bootstrap.min.css";
@import "./css/index.css";
@import "./css/aos.css"
</style>
